export default __webpack_public_path__ + "static/media/dessert.47154e66.png";